module.exports = __webpack_public_path__ + "img/icon-globe.25836c4b.svg";